import { render, staticRenderFns } from "./vehiclebaseinfo.vue?vue&type=template&id=8d7b72ce&scoped=true"
import script from "./vehiclebaseinfo.vue?vue&type=script&lang=js"
export * from "./vehiclebaseinfo.vue?vue&type=script&lang=js"
import style0 from "./vehiclebaseinfo.vue?vue&type=style&index=0&id=8d7b72ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7b72ce",
  null
  
)

export default component.exports